import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-external-link-modal',
  templateUrl: './external-link-modal.component.html',
  styleUrls: ['./external-link-modal.component.css']
})
export class ExternalLinkModalComponent {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
